const types = {
    SET_COMPLETED_CASE_LIST_LOADING: 'SET_COMPLETED_CASE_LIST_LOADING',
    SET_COMPLETED_NO_RX_CASE_LIST_LOADING: 'SET_COMPLETED_NO_RX_CASE_LIST_LOADING',
    SET_COMPLETED_CASE_LIST: 'SET_COMPLETED_CASE_LIST',
    SET_COMPLETED_NO_RX_CASE_LIST: 'SET_COMPLETED_NO_RX_CASE_LIST',
};

export default types;